import React from "react";
import {
  faBook,
  faFileLines,
  faLightbulb,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress, Grid, Paper, Typography } from "@mui/material";
import { Box } from "@mui/material";

const CaseDetailMaxims = ({ loading, maxims }) => {
  const cardConfigs = [
    {
      title: "Maxims",
      icon: faLightbulb,
      bgColor: "#EFF6FF",
      iconColor: "#2563EB",
      hoverBorderColor: "#2563EB",
      hoverShadowColor: "rgba(37, 99, 235, 0.08)",
      items: maxims?.Maxims || {},
      itemHoverBgColor: "#EFF6FF",
      itemTitleColor: "#2563EB",
    },
    {
      title: "Terms",
      icon: faBook,
      bgColor: "#ECFDF5",
      iconColor: "#059669",
      hoverBorderColor: "#059669",
      hoverShadowColor: "rgba(5, 150, 105, 0.08)",
      items: maxims?.Legal_Terms || {},
      itemHoverBgColor: "#ECFDF5",
      itemTitleColor: "#059669",
    },
    {
      title: "Words & Phrases",
      icon: faFileLines,
      bgColor: "#F5F3FF",
      iconColor: "#7C3AED",
      hoverBorderColor: "#7C3AED",
      hoverShadowColor: "rgba(124, 58, 237, 0.08)",
      items: maxims?.Words_and_Phrases || {},
      itemHoverBgColor: "#F5F3FF",
      itemTitleColor: "#7C3AED",
    },
  ];

  return (
    <Box sx={{ p: { xs: 1.5, md: 2 } }}>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginY: "12px",
            height: "100%",
            width: "100%",
          }}
        >
          <CircularProgress
            size={20}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          />
        </Box>
      ) : (
        <Grid container spacing={2}>
          {cardConfigs.map((config) => (
            <Grid item xs={12} md={4}>
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  height: "100%",
                  bgcolor: "#FFFFFF",
                  border: "1px solid #E2E8F0",
                  borderRadius: "12px",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    borderColor: config.hoverBorderColor,
                    boxShadow: `0 4px 12px ${config.hoverShadowColor}`,
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 2,
                    pb: 1.5,
                    borderBottom: "1px solid #E2E8F0",
                  }}
                >
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: config.bgColor,
                      borderRadius: "8px",
                      color: config.iconColor,
                    }}
                  >
                    <FontAwesomeIcon
                      icon={config.icon}
                      style={{ fontSize: "0.875rem" }}
                    />
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: "0.9375rem",
                      fontWeight: 600,
                      color: "#1E293B",
                    }}
                  >
                    {config.title}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                  }}
                >
                  {Object.entries(config.items).map(([key, value]) => (
                    <Box
                      key={key}
                      sx={{
                        p: 1.5,
                        bgcolor: "#F8FAFC",
                        borderRadius: "8px",
                        border: "1px solid #E2E8F0",
                        transition: "all 0.2s ease",
                        "&:hover": {
                          borderColor: config.hoverBorderColor,
                          bgcolor: config.itemHoverBgColor,
                          transform: "translateY(-1px)",
                        },
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color: config.itemTitleColor,
                          fontSize: "0.8125rem",
                          fontWeight: 600,
                          mb: 0.75,
                        }}
                      >
                        {key}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#334155",
                          fontSize: "0.8125rem",
                          lineHeight: 1.5,
                        }}
                      >
                        {value}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default CaseDetailMaxims;
